import React, { useEffect, useState } from "react";
import MainBg from "../../components/Mainbg";
import {
  Tooltip,
  Cell,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  LineChart,
  Line,
} from "recharts";
import secureLocalStorage from "react-secure-storage";
import BaseImage from "../../assets/images/dasboard/base.webp";

import axios from "axios";
import { GET_TRACK_WATER } from "../../config/ApisCollection";
import {
  monthlist,
  getDatesWithDayNames,
  WeekInMonth,
} from "../../function/functions";
import WaterIntakeSection from "../../sections/WaterIntakeSection";
import tracknotfound from "../../assets/images/track-not-found.png";
import {
  DaySlideSection,
  DayWeekTabSection,
  NotFound,
  TrackDateFilterSection,
  WeekSlideSection,
} from "../../components/TrackCommonSection";

const WaterTrack = ({ weekStart = "Sunday" }) => {
  const accessToken = secureLocalStorage.getItem("accessToken");
  // Update current date, month, and year on component mount
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed and should be 2 digits
  const day = String(now.getDate()).padStart(2, "0"); // Ensure day is 2 digits
  const current_date = `${year}-${month}-${day}`; // Ensure day is 2 digits
  // const dayOfWeek = now.getDay();
  const dayOfWeek = day;

  // const current_month = month;
  const current_dayinweek = 3;
  // Get the current week of the month
  const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const firstWeekday = firstDayOfMonth.getDay(); // Day of the week for the 1st of the month
  const currentWeekfind = Math.ceil((now.getDate() + firstWeekday) / 7); // Week number in the month

  // console.log(currentWeekfind);
  const [dataTab, setDataTab] = useState("Daily");
  const [bardata, setBarData] = useState([]);
  const [linedata, setLineData] = useState([]);
  const [activeDayTab, setActiveDayTab] = useState(current_date || null);
  const [activeWeekTab, setActiveWeekTab] = useState(currentWeekfind - 1);
  const [currentMonth, setCurrentMonth] = useState(month || null);
  const [currentYear, setCurrentYear] = useState(year || null);
  const [reportData, setReportData] = useState(null);
  const [currentWaterSummary, setCurrentWaterSummary] = useState(null);

  const weeklist = ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"];
  // Function to get the current week with dates and day names

  const handleChange = (event) => {
    setCurrentMonth(event.target.value);
  };

  const GetTrackReport = async () => {
    const getParams = {
      month: currentMonth,
      year: currentYear,
    };

    const getHeaders = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.post(GET_TRACK_WATER, getParams, getHeaders);

      setReportData(response.data);
      //------------Bar-data-----------------------------------
      let bar_data_arr = [];
      response.data &&
        response.data?.logtrack[currentYear + "-" + currentMonth][
          "week" + (activeWeekTab + 1)
        ]?.dailyData?.forEach((item, index) => {
          const shortFormatedYmd = new Date(item?.date).toLocaleString(
            "en-US",
            {
              day: "numeric",
              month: "short",
            }
          );
          bar_data_arr.push({
            name: shortFormatedYmd,
            ML: item?.waterTaken || 0,
          });
        });
      setBarData(bar_data_arr);

      //-----------------------Daily data----------------------
      // Day Line data
      let line_data_arr = [
        {
          ML: 0,
        },
      ];

      let line_water_current_total = 0;
      let line_water_current_sum = null;

      // console.log(reportData);
      response?.data &&
        response?.data?.log?.forEach((item, index) => {
          const shortFormatedYmd = new Date(item?.createdAt).toLocaleString(
            "en-US",
            {
              day: "numeric",
              month: "numeric",
              year: "numeric",
            }
          );
          const shortFormatedYmd_activeDayTab = new Date(
            activeDayTab
          ).toLocaleString("en-US", {
            day: "numeric",
            month: "numeric",
            year: "numeric",
          });

          if (shortFormatedYmd == shortFormatedYmd_activeDayTab) {
            line_data_arr.push({
              ML: item?.waterTaken || 0,
            });

            line_water_current_total += item?.waterTaken;

            line_water_current_sum = {
              waterIntakeperDay: response?.data?.todayTotal,
              todayTotalWaterintake: line_water_current_total,
              waterIntakeType: item?.quantityUnit,
              waterIntakepercentage: 100,
              waterRecommendation: response?.data?.perdayavg,
            };
          }
        });
      setCurrentWaterSummary(line_water_current_sum);
      setLineData(line_data_arr);
    } catch (error) {
      // console.log(error);
    }
  };

  // const currentWeek = getCurrentWeek(weekStart);
  const currentWeek = getDatesWithDayNames(year, currentMonth - 1);

  // console.log(dates);

  useEffect(() => {
    GetTrackReport();
  }, [activeDayTab, currentMonth, activeWeekTab]);

  return (
    <MainBg>
      <div className="container lg:w-1/4 md:w-1/3 w-full m-auto">
        <TrackDateFilterSection
          currentMonth={currentMonth}
          month={month}
          year={year}
          monthlist={monthlist}
          setCurrentYear={setCurrentYear}
          currentYear={currentYear}
          handleChange={handleChange}
        />

        <DayWeekTabSection dataTab={dataTab} setDataTab={setDataTab} />
      </div>
      {dataTab === "Daily" ? (
        <>
          {/* Daily based data report  */}
          {/* Date and day tabs  */}
          <DaySlideSection
            activeDayTab={activeDayTab}
            currentWeek={currentWeek}
            dayOfWeek={dayOfWeek}
            setActiveDayTab={setActiveDayTab}
          />

          <>
            {/* Workout list set left  */}
            <div className="container mx-auto p-4 py-20">
              {linedata && linedata?.length >= 2 ? (
                <>
                  {" "}
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    {/* Table section  */}

                    <div>
                      <div className="py-5">
                        <div className="px-30">
                          {reportData ? (
                            <WaterIntakeSection
                              waterData={currentWaterSummary}
                              numGlass={0}
                              setIsWaterIntakeOpen={null}
                            />
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                      <div className=""></div>
                    </div>
                    {/* Line graph right section */}
                    <div className="px-20">
                      <ResponsiveContainer width="100%" height="100%">
                        <LineChart width={300} height={100} data={linedata}>
                          <defs>
                            <radialGradient
                              id="radialGradient"
                              cx="50%"
                              cy="50%"
                              r="50%"
                              fx="50%"
                              fy="50%"
                            >
                              <stop
                                offset="20%"
                                stopColor="rgba(115,80,255,1)"
                              />
                              <stop
                                offset="100%"
                                stopColor="rgba(255,153,80,1)"
                              />
                            </radialGradient>
                          </defs>
                          <Line
                            type="monotone"
                            dataKey="ML"
                            stroke="url(#radialGradient)" // Use the radial gradient here
                            strokeWidth={5}
                          />
                          <Tooltip />
                          <XAxis />
                        </LineChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </>
              ) : (
                reportData && <NotFound />
              )}
            </div>
          </>
        </>
      ) : (
        <>
          {/* Weekly active tab  */}
          <WeekSlideSection
            weeklist={weeklist}
            activeWeekTab={activeWeekTab}
            setActiveWeekTab={setActiveWeekTab}
            currentWeekfind={currentWeekfind}
          />
          <div className="container mx-auto p-4 py-20">
            {bardata && bardata?.length > 0 ? (
              <>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  {/* Table section  */}

                  <div>
                    {reportData &&
                      reportData?.logtrack[currentYear + "-" + currentMonth] &&
                      reportData?.logtrack[currentYear + "-" + currentMonth][
                        "week" + (activeWeekTab + 1)
                      ]?.dailyData?.map((week_day, index) => {
                        const shortFormatedYmd = new Date(
                          week_day?.date
                        ).toLocaleString("en-US", {
                          day: "numeric",
                          month: "short",
                        });
                        return (
                          <div key={index}>
                            <div className="flex border-b justify-between	items-center">
                              <div className="p-2 text-capitalize">
                                <p>
                                  {shortFormatedYmd}, {/* {week_day?.)} */}
                                </p>
                              </div>
                              {week_day ? (
                                <div className="flex">
                                  <div className="p-2">
                                    <p className="font-bold">
                                      {week_day?.waterTaken +
                                        " " +
                                        week_day?.quantityUnit}
                                    </p>
                                    <div className="text-xs flex items-center gap-1">
                                      <div className="h-[8px] w-[8px] bg-[#FE7701] rounded-full"></div>{" "}
                                      Consumption
                                    </div>
                                  </div>
                                  {/* <div className="p-2">
                                <p className="font-bold">
                                  {week_day[1][0]?.logInMinutes_eating}m
                                </p>
                                <div className="text-xs flex items-center gap-1">
                                  <div className="h-[8px] w-[8px] bg-[#ffdabf5c] rounded-full"></div>{" "}
                                  Eating
                                </div>
                              </div> */}
                                </div>
                              ) : (
                                <>No record</>
                              )}
                            </div>
                          </div>
                        );
                      })}
                  </div>

                  {/* Graph section */}

                  <div>
                    <div>
                      <span className="text-[#FE7701] text-[24px]">
                        {reportData?.logtrack?.[
                          currentYear + "-" + currentMonth
                        ] &&
                          reportData?.logtrack?.[
                            currentYear + "-" + currentMonth
                          ]["week" + (activeWeekTab + 1)]?.total}{" "}
                        mL
                      </span>{" "}
                      <span className="text-[#000] text-[24px]">consumed</span>
                    </div>
                    <p className="text-[#7f7f7f] text-[12px]">
                      Data from your water intake logs{" "}
                    </p>

                    <ResponsiveContainer width="100%" height="80%">
                      <BarChart
                        width={500}
                        height={300}
                        data={bardata}
                        margin={{
                          top: 20,
                          right: 30,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        {/* <YAxis /> */}
                        {/* <Tooltip /> */}
                        <Legend />
                        <Bar dataKey="ML" stackId="a" fill="#FF9950" />
                        {/* <Bar dataKey="Eating" stackId="a" fill="#ffeee2" /> */}
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </>
            ) : (
              <NotFound />
            )}
          </div>
        </>
      )}
    </MainBg>
  );
};

export default React.memo(WaterTrack);
